import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import { useContent } from "./ContentContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faXmark } from "@fortawesome/free-solid-svg-icons";

// Import local images as fallbacks
import instagram from "../src/public/images/instagram.png";
import communication from "../src/public/images/communication.png";
import linkedin from "../src/public/images/linkedin.png";
import logoname from "./public/images/logo.png";
import MainLogo from "../src/public/images/logo.png";


export default function Navbar() {
  const { content, loading } = useContent();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = (route) => {
    navigate(route);
    setOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (loading || !content) {
    return <div className="navbar" style={{ background: "#000", height: "80px" }}></div>;
  }

  const { global } = content;
  const navbarItems = global?.navbar || [];
  const socialLinks = global?.socialLinks || {};

  return (
    <>
      <div className="navbar">
        <img src={MainLogo} className="nav-logo" alt={global?.siteName || "Logo"} onClick={() => navigate("/")} />

        <div className="header-right">
          <div className="social-icons">
            <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src={communication} className="icon" alt="Facebook" />
            </a>
            {/* <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src={twitter} className="icon" alt="Twitter" />
            </a> */}
            <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src={instagram} className="icon" alt="Instagram" />
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
              <img src={linkedin} className="icon" alt="LinkedIn" />
            </a>
          </div>

          <div className="hamburger" onClick={() => setOpen((prev) => !prev)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {open && (
        <div className="menu-overlay">
          <div className="menu-topbar">
            <button
              type="button"
              className="menu-back-btn"
              onClick={() => handleClick("/")}
            >
              <FontAwesomeIcon icon={faArrowLeft} className="menu-back-icon" />
              <span>Back</span>
            </button>

            <button
              type="button"
              className="close-btn"
              aria-label="Close menu"
              onClick={() => setOpen(false)}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          <div className="menu-content">
            <div className="menu-left">
              <div className="menu-list">
                {navbarItems.slice(0, 6).map((item, idx) => (
                  <p key={idx} className="menu-main" onClick={() => handleClick(item.link)}>{item.label}</p>
                ))}
              </div>
            </div>

            <div className="menu-right">
              <img src={logoname} className="nav-logoname" alt={global?.siteName || "Logo"} />
              <div className="menu-links NavSectionLinks">
                {navbarItems.slice(6).map((item, idx) => (
                  <p key={idx} onClick={() => handleClick(item.link)}>{item.label}</p>
                ))}
              </div>

              <div className="social-icons">
                <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social-icon">
                  <img src={communication} className="icon" style={{ width: "45px", height: "36px" }} alt="Facebook" />
                </a>
                <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-icon">
                  <img src={instagram} className="icon" style={{ width: "45px", height: "36px" }} alt="Instagram" />
                </a>
                <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                  <img src={linkedin} className="icon" style={{ width: "45px", height: "36px" }} alt="LinkedIn" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
